// extracted by mini-css-extract-plugin
export default {"voiceOption":"VoiceProfile_voiceOption__xMi-3","voiceOptionItem":"VoiceProfile_voiceOptionItem__AYnAP","voiceOptionItemClicked":"VoiceProfile_voiceOptionItemClicked__ZShhW"};